(function (module) {

    module.service('marketBrandService', ['$http', marketBrandService])

    function marketBrandService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.get = () => {
            return $http.get('/api/configuration/market-brand')
                .then(function (response: $TSFixMe) {
                    return response.data;
                });
        };

        service.getAsListOfStrings = () => service.get().then((items: $TSFixMe) => items.map((item: $TSFixMe) => item.name));

        service.import = () => $http.post('/api/configuration/import-brands', null);

    }

})(angular.module('topline.modules'));